import { useGetApiEasyAdministrationArea } from "../../../../../openapi/backendApi";

import { JSX } from "react";
import ReactGA from "react-ga4";

import { PrintButtonArea } from "@4pace-print-button-area/core";
import {
  useCsAttributes,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { Gateway } from "@plansoft-configuration-renderer/gateway";
import { useQueryClient } from "@tanstack/react-query";

export const UtilsProductView = (): JSX.Element => {
  const queryClient = useQueryClient();
  const sessionId = useSessionId();
  const atts = useCsAttributes();

  const { data: admindata } = useGetApiEasyAdministrationArea();
  //const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const adminArea = admindata?.data.string;

  const typeDesignationObj = atts.find(
    (att) => att.id === "A_TYPE_DESIGNATION",
  );

  let documentName = "";
  if (typeDesignationObj && typeDesignationObj.values) {
    documentName = typeDesignationObj.values[0].value;
  }
  if (documentName) {
    documentName = documentName.replace(/[\\./]/g, "_");
  } else {
    documentName = "WEG-DataSheet";
  }

  let areaIdentifier = "";
  if (adminArea === "WCES") {
    areaIdentifier = "printDataSheetWCES";
  } else if (adminArea === "WGS") {
    areaIdentifier = "printDataSheetWGS";
  } else {
    console.error("Invalid administration area in UtilsProductView", adminArea);
    areaIdentifier = "printDataSheetWGS";
  }

  /* const handlePrintBlob = (blob: Blob): void => {
    const newFile = new File([blob], documentName, { type: blob.type });
    setFileUrl(URL.createObjectURL(newFile));
    setIsModalOpen(true);
  };
 */
  return (
    <>
      <Gateway into="configurator-footer-right">
        <PrintButtonArea
          queryClient={queryClient}
          areaIdentifier={areaIdentifier}
          locale="en-US"
          printRequestParams={{
            quoteId: sessionId,
          }}
          options={{
            //    orchestratorBasePath: "/preview",
            areaSx: { display: "flex", gap: 1 },
            buttonProps: {
              sx: {
                default: { textTransform: "uppercase" },
              },
            },
          }}
          fileName={documentName}
          beforePrintCallback={() => {
            ReactGA.event({ category: "User", action: "Download Datasheet" });
          }}
        />
      </Gateway>
      {/*       <BaseModal
        isOpen={isModalOpen && !!fileUrl}
        onClose={() => {
          setIsModalOpen(false);
        }}
        customSx={{
          height: "100vh",
          width: "calc(21cm + 32px)",
          maxWidth: "95vw",
          ">.MuiBox-root": {
            height: "100%",
            ">.MuiBox-root": {
              height: "100%",
              p: 0,
              display: "flex",
              flexDirection: "column",
            },
          },
        }}
        customBodySx={{ flexGrow: 1, p: 1 }}
      >
        <Box height="100%" display="flex" flexDirection="column"> */}
      {/*     <Box display="flex" mb={1} justifyContent="flex-end">
            <Button
              component={Link}
              to={fileUrl}
              download={documentName}
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
            >
              {t("CustomApp:buttons.download")}
            </Button>
          </Box> */}
      {/*  <a
            href={blobUrl}
            target="_blank"
            rel="noreferrer"
            download={documentName}
          >
            test
          </a> */}
      {/*     <Box flexGrow={1}>
            <embed src={fileUrl} width="100%" height="100%" />
          </Box>
        </Box>
      </BaseModal> */}
    </>
  );
};
